// src/components/WebsiteVisits/LeadScore.jsx
import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";

const BRAND_BLUE = "#00336C";

/* =========================================================
   Helpers
========================================================= */

function normalizeName(name) {
  if (!name) return "";
  return name
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, "")
    .replace(/\b(inc|llc|co|org|foundation|corp|corporation)\b/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

/* =========================================================
   LeadScore Badge (Display Only)
   🔒 Score now comes from backend
========================================================= */

export default function LeadScore({
  score,
  visitorName,
  clientName,
  size = "small",
  showTooltip = true,
}) {
  const cleanVisitor = normalizeName(visitorName);
  const cleanClient = normalizeName(clientName);

  const isSelfVisit =
    cleanVisitor && cleanClient && cleanVisitor === cleanClient;

  const fontSize = size === "large" ? "1rem" : "0.9rem";

  // === SELF VISIT (hide score)
  if (isSelfVisit) {
    return (
      <Typography
        sx={{
          fontWeight: 600,
          fontSize,
          color: BRAND_BLUE,
        }}
      >
        — — —
      </Typography>
    );
  }

  if (score == null) return null;

  const content = (
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: 17,
        color: BRAND_BLUE,
      }}
    >
      {score}
    </Typography>
  );

  if (!showTooltip) return content;

  return (
    <Tooltip
      arrow
      title={
        <Box sx={{ fontSize: "0.75rem" }}>
          <div>Score calculated from engagement signals:</div>
          <div>• Repeat visits</div>
          <div>• Time on site</div>
          <div>• Target industry alignment</div>
          <div>• Intent page views</div>
          <div>Score capped at 100</div>
        </Box>
      }
    >
      {content}
    </Tooltip>
  );
}
